<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'PageInit',
  data: () => {
    return {

    }
  },

  methods: {
    params: function () {
      var lookup = {}

      var href = window.location.href.replace(/^(#\/)+|(#\/)+$/gm, '')
      var query = href.split('?')

      if (query.length !== 2) return lookup

      var params = query[1].split('&')
      for (var i = 0; i < params.length; i++) {
        var keyVal = params[i].split('=')
        if (keyVal.length !== 2) continue

        keyVal[0] = decodeURIComponent(keyVal[0])
        keyVal[1] = decodeURIComponent(keyVal[1])

        lookup[keyVal[0]] = keyVal[1]
      }

      return lookup
    }
  },

  mounted: function() {
    var vm = this

    var params = vm.params()
    var companyId = params.CompanyID
    var officerId = params.OfficerID
    var realtorId = params.RealtorID

    Promise.all([
      this.$store.dispatch('initCompany', companyId),
      this.$store.dispatch('initOfficer', { CompanyID: companyId, UserID: officerId }),
      this.$store.dispatch('initRealtor', realtorId)
    ])
    .then(r => {
      var target = 'start'
      var company = r[0]

      if (!company) 
        target = 'error'

      vm.$store.commit('setReady', true)
      vm.$store.dispatch('go', target)
    })
  }
}
</script>

<style scoped lang="scss">

</style>
